<template>
    <div class="evalua">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">{{ column }}</div>
            </div>
        </div>
        <div class="asstes" ref="pdfContent">
          <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
            <el-tab-pane v-for="(value,index) in selectedValues" :key="index" :label="value.name" :name="value.id">
              <el-form ref="form" :model="form" class="item scoring_class">
                <el-tabs v-model="activeName1" type="card">
                  <el-tab-pane label="粗动作" v-if="form.grossMotor && form.grossMotor.length > 0" name="1">
                      <el-form-item v-for="(item,i) in form.grossMotor" :key="i" :label="item.title">
                        <div class="erro" @click="handleClick('erro',item,'grossMotor',i)">{{item.select}}<span v-if="item.checkedLength1 * 1 > 0">（{{ item.checkedLength1 }}）</span></div>
                        <div class="sens" @click="handleClick('sens',item,'grossMotor',i)">{{item.sens}}<span v-if="item.checkedLength2 * 1 > 0">（{{ item.checkedLength2 }}）</span></div>
                      </el-form-item>
                  </el-tab-pane>
                  <el-tab-pane label="粗动作动态" v-if="form.grossMotorDynamic && form.grossMotorDynamic.length > 0" name="2">
                      <el-form-item v-for="(item,i) in form.grossMotorDynamic" :key="i" :label="item.title">
                        <div class="erro" @click="handleClick('erro',item,'grossMotorDynamic',i)">{{item.select}}<span v-if="item.checkedLength1 * 1 > 0">（{{ item.checkedLength1 }}）</span></div>
                        <div class="sens" @click="handleClick('sens',item,'grossMotorDynamic',i)">{{item.sens}}<span v-if="item.checkedLength2 * 1 > 0">（{{ item.checkedLength2 }}）</span></div>
                      </el-form-item>
                  </el-tab-pane>
                  <el-tab-pane label="细动作" v-if="form.fineMotor && form.fineMotor.length > 0" name="3">
                      <el-form-item v-for="(item,i) in form.fineMotor" :key="i" :label="item.title">
                        <div class="erro" @click="handleClick('erro',item,'fineMotor',i)">{{item.select}}<span v-if="item.checkedLength1 * 1 > 0">（{{ item.checkedLength1 }}）</span></div>
                        <div class="sens" @click="handleClick('sens',item,'fineMotor',i)">{{item.sens}}<span v-if="item.checkedLength2 * 1 > 0">（{{ item.checkedLength2 }}）</span></div>
                      </el-form-item>
                  </el-tab-pane>
                  <el-tab-pane label="细动作动态" v-if="form.fineMotorDynamic && form.fineMotorDynamic.length > 0" name="4">
                      <el-form-item v-for="(item,i) in form.fineMotorDynamic" :key="i" :label="item.title">
                        <div class="erro" @click="handleClick('erro',item,'fineMotorDynamic',i)">{{item.select}}<span v-if="item.checkedLength1 * 1 > 0">（{{ item.checkedLength1 }}）</span></div>
                        <div class="sens" @click="handleClick('sens',item,'fineMotorDynamic',i)">{{item.sens}}<span v-if="item.checkedLength2 * 1 > 0">（{{ item.checkedLength2 }}）</span></div>
                      </el-form-item>
                  </el-tab-pane>
                  <el-tab-pane label="测评观察" name="5">
                      <div class="scoring">
                        <div class="tit">
                          <ul style="width: 200px;">
                            <li :class="item.class" v-for="(item,index) in dictData" :key="index" @click="changeTypeValue(item, index)">{{ item.dic.name }}</li>
                          </ul>
                        </div>
                        <el-checkbox-group :max="15" v-model="form.evaluationObservationChecked">
                          <el-checkbox v-if="item.type_value == curTypeValue" v-for="item in form.evaluationObservation" :key="item.index" :label="item.label" :disabled="isDisabled"></el-checkbox>
                        </el-checkbox-group>
                      </div>
                  </el-tab-pane>
                  <el-tab-pane label="能量状态" name="6">
                      <div class="scoring">
                        <div class="tit">能量状态</div>
                        <el-radio-group v-model="form.energyStateChecked">
                          <el-radio v-for="item in form.energyState" :key="item.index" :label="item.label" :disabled="isDisabled"></el-radio>
                        </el-radio-group>
                      </div>
                  </el-tab-pane>
                  <el-tab-pane label="感统年龄" name="7" class="parcage">
                    <el-descriptions :column="1">
                        <el-descriptions-item label="实际年龄：">{{ form.age }}</el-descriptions-item>
                        <el-descriptions-item label="上次测评：" v-if="form.hasEvalua">有测评数据</el-descriptions-item>
                        <el-descriptions-item label="测评老师：">{{ form.teacher_name }}</el-descriptions-item>
                        <el-descriptions-item label="测评日期：">{{ form.evalua_time }}</el-descriptions-item>
                        <el-descriptions-item label="粗动作年龄：">{{ form.gross_motor_age }}</el-descriptions-item>
                        <el-descriptions-item label="粗动作状态：">
                          <!-- <el-input class="m_input" v-model="form.gross_motor_state"></el-input> -->
                          <el-select v-model="form.gross_motor_state" placeholder="请选择" :width="100" :disabled="isDisabled">
                            <el-option :width="100"
                              v-for="item in selOptions2"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-descriptions-item>
                        <el-descriptions-item label="细动作年龄：">{{ form.fine_motor_age }}</el-descriptions-item>
                        <el-descriptions-item label="细动作状态：">
                          <!-- <el-input class="m_input" v-model="form.fine_motor_state"></el-input> -->
                          <el-select v-model="form.fine_motor_state" placeholder="请选择" :width="100" :disabled="isDisabled">
                            <el-option :width="100"
                              v-for="item in selOptions2"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-descriptions-item>
                        <el-descriptions-item label="观测标签：">
                          <el-input class="m_input" v-model="form.observation_label" :disabled="isDisabled"></el-input>
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-form-item label="粗动作年龄" class="cage">
                      <el-select v-model="form.gross_motor_age" placeholder="请选择" :width="100" :disabled="isDisabled">
                        <el-option :width="100"
                          v-for="item in ageSelectData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="细动作年龄" class="cage">
                      <el-select v-model="form.fine_motor_age" placeholder="请选择" :width="100" :disabled="isDisabled">
                        <el-option :width="100"
                          v-for="item in ageSelectData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-tab-pane>
                </el-tabs>
                <div class="btn">
                  <el-button class="save" @click="saveData(0)" v-if="!showReport">保存数据</el-button>
                  <el-button class="sub" @click="submitEvaluation" v-if="!showReport">提交测评</el-button>                  
                  <el-button type="primary" icon="el-icon-view" v-if="showReport && form.status < 2" @click="previewReport">预览报告</el-button>
                  <el-button type="info" :disabled="true" v-if="form.status == 2">已确认报告</el-button>
                  <!-- <el-button class="look" v-if="showReport" @click="viewReport">查看报告</el-button> -->
                  <!-- <el-dropdown :hide-on-click="false">
                    <el-button type="primary" :loading="loading">
                      更多3<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click="previewReport()">预览报告</el-dropdown-item>
                      <el-dropdown-item @click="confirmReport">确认报告</el-dropdown-item>
                      <el-dropdown-item @click="reEvaluate">重新测评</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown> -->
                  <el-button v-if="showReport" type="primary" @click="showDrawer = true">
                    更多<i class="el-icon-arrow-right el-icon--right"></i>
                  </el-button>

                  <!-- 右侧抽屉 -->
                  <el-drawer
                    title="操作选项"
                    :visible.sync="showDrawer"
                    direction="rtl"
                    size="20%"
                  >
                    <div style="display: flex; flex-direction: column; gap: 15px; padding: 10px;">
                      <el-button type="success" v-if="showReport && form.status < 2" icon="el-icon-check" @click="confirmReport" style="margin-left: 0;">确认报告</el-button>
                      <el-button type="success" icon="el-icon-view" @click="viewReport" style="margin-left: 0;">查看报告</el-button>
                      <el-button type="warning" icon="el-icon-refresh" @click="reEvaluate" style="margin-left: 0;">重新测评</el-button>
                    </div>
                  </el-drawer>
              </div>
            </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 保存提示 -->
         <el-alert title="保存成功" :class="showSave" type="success"></el-alert>
         <el-alert title="提交成功" :class="showSub" type="success"></el-alert>
        <!-- 弹窗1 -->
        <el-dialog
          :title="'请给学生测评打分，当前项目：【' + curProjectName + '】'"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleDialogClose">
          <el-form>
            <el-form-item>
              <el-radio-group v-model="dialogSelection" :disabled="isDisabled">
                <el-radio label="优秀" @change="handleRadioChange">优秀</el-radio>
                <el-radio label="标准" @change="handleRadioChange">标准</el-radio>
                <el-radio label="错误" @change="handleRadioChange">错误</el-radio>
                <el-radio label="不会" @change="handleRadioChange">不会</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-checkbox-group v-model="checkedAss" :disabled="isDisabled"> <!-- :disabled="isDisabled" -->
                  <el-checkbox v-for="item in form.bodyPart" :label="item" :key="item">{{ item }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="confirmSelection">确认</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 弹窗2 -->
        <el-dialog
          title="选择测试项目"
          :visible.sync="dialogVisible2"
          width="30%">
          <el-form>
            <el-form-item>
              <el-checkbox-group v-model="checkedAss">
                  <el-checkbox :disabled="isDisabled"  v-for="item in form.bodyPart" :label="item" :key="item">{{ item }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="confirmScoring">确认</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 隐藏的下载链接 -->
        <a ref="downloadLink" :href="downloadUrl" style="display: none" target="_blank"></a>
    </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep'
import { getEvaluaParams, saveEvaluaData, saveEvaluaFinish, viewReport, userEditMultiple } from '@/api/app'
//import html2pdf from 'html2pdf.js'
import useAppStore from '../stores/modules/app'
import { Loading } from 'element-ui'
// import { first } from 'lodash'
// import { setUserInfo } from '@/api/user'
export default {
  name: 'Evalua',
  data () {
    return {
      loadingInstance: null,
      downloadUrl: '',
      column: '我的测评',
      activeName: '0',
      activeName1: '1',
      selectedValues: [],
      selectedIds: [],
      tabDataArray: {},
      prevTabIndex: 0,
      checkedAss: [],
      // check: [],
      // check2: [],
      evaluaRecord: [],
      form: {},
      tabData: {},
      selOptions2: [
          { value: '优秀', label: '优秀' },
          { value: '轻度', label: '轻度' },
          { value: '中度', label: '中度' },
          { value: '重度', label: '重度' },
        ],
      dialogSelection: '',
      dialogScoring: '',
      currentRegion: '',
      seleValue: '',
      currentLabel: '',
      previousLabel: '',
      showReport: false,
      showSave: 'close',
      showSub: 'close',
      dialogVisible: false, // 弹窗显示控制
      dialogVisible2: false, // 弹窗显示控制
      dialogVisible3: false, // 弹窗显示控制
      isDisabled: true,
      selectedIndex: null,
      selectedRegion: null,
      selectedType: null,
      selectedItems: [],
      curProjectName: '',
      dictData: [],
      curTypeValue: 'positive',
      loading: false,
      showDrawer: false, // 控制抽屉的显示/隐藏
      appStore: null,
      ageSelectData: []
    }
  },
  created () {
    const selected = this.$route.query.selected
    const nameStr = this.$route.query.nameStr
    if (nameStr) {
      let nameAry = nameStr.split(',')
      let idAry = selected.split(',')
      this.selectedValues = []
      for (let i = 0; i < nameAry.length; i++) {
        this.selectedValues.push(
          {'name': nameAry[i], 'id': idAry[i]}
        )
      }
    } else {
      // 如果没有选中的值，提示用户或进行其他处理
      this.$message.error('没有选中的值')
    }
    this.appStore = useAppStore()
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      const params = {
        student_ids: this.$route.query.selected
      }
      const fData = await getEvaluaParams(params)
      if(fData.dictData.length > 0){
        for(let i = 0; i < fData.dictData.length; i++){
          // 处理字典数据
          if(fData.dictData[i].dic_type === 'age'){
            if(fData.dictData[i].sub.length > 0){
              this.ageSelectData = fData.dictData[i].sub.map(item => ({value: item.value, label: item.value}))
              // 如果只有一个选项，自动选中
              if (this.ageSelectData.length === 1) {
                this.form.gross_motor_age = this.ageSelectData[0].value
                this.form.fine_motor_age = this.ageSelectData[0].value
              }
            } else {
              this.ageSelectData = []
            }
          }
        }
      }
      console.log('students====', this.ageSelectData )
      
      if(fData.evaluaRecord.length === 0) {
        this.$router.push('/table')
        return
      }
      // this.form = fData.form
      this.evaluaRecord = fData.evaluaRecord
      this.dictData = fData.dictData      
      //console.log('students====', fData)
      fData.form['hasEvalua'] = true
      for (let i = 0; i < this.evaluaRecord.length; i++) {
        if (this.evaluaRecord[i].evalua_project === '') {
          fData.form['evalua_id'] = this.evaluaRecord[i].id
          fData.form['age'] = this.evaluaRecord[i].age
          fData.form['hasEvalua'] = false
          fData.form['is_finish'] = false
          fData.form['student_id'] = this.evaluaRecord[i].student_id
          fData.form['student_name'] = this.evaluaRecord[i].student_name
          fData.form['teacher_name'] = this.evaluaRecord[i].teacher_name
          fData.form['evalua_time'] = this.evaluaRecord[i].evalua_time
          fData.form['gross_motor_age'] = 1
          fData.form['fine_motor_age'] = 1
          fData.form['gross_motor_state'] = ''
          fData.form['fine_motor_state'] = ''
          fData.form['observation_label'] = ''
          fData.form['energyStateChecked'] = ''
          this.evaluaRecord[i].evalua_project = cloneDeep(fData.form)
        } else {
          this.evaluaRecord[i].evalua_project = JSON.parse(this.evaluaRecord[i].evalua_project)         
          //console.log('students888====', this.evaluaRecord[i])
        }
        // this.tabDataArray.push(this.evaluaRecord[i].evalua_project)
        this.tabDataArray[this.evaluaRecord[i].student_id] = this.evaluaRecord[i].evalua_project
        this.tabDataArray[this.evaluaRecord[i].student_id]['status'] = this.evaluaRecord[i].status
        // this.tabDataArray.push({ ...this.form })
        // console.log('students====', this.evaluaRecord[i])
      }
      let firstId = this.$route.query.selected.split(',')[0]
      //console.log('students====', firstId,this.tabDataArray[firstId])
      this.activeName = firstId
      this.form = this.tabDataArray[firstId] //this.evaluaRecord[0].evalua_project
      this.form['evaluationObservation'] = fData.form.evaluationObservation
      this.isDisabled = this.form.is_finish
      this.showReport = this.form.is_finish
      // 动态设置第一个可见的子tab为默认选中
      if (this.form.grossMotor && this.form.grossMotor.length > 0) {
        this.activeName1 = '1'
      } else if (this.form.grossMotorDynamic && this.form.grossMotorDynamic.length > 0) {
        this.activeName1 = '2'
      } else if (this.form.fineMotor && this.form.fineMotor.length > 0) {
        this.activeName1 = '3'
      } else if (this.form.fineMotorDynamic && this.form.fineMotorDynamic.length > 0) {
        this.activeName1 = '4'
      } else {
        this.activeName1 = '5'
      }
      console.log('form====', this.form)
    },
    goBack () {
      this.$router.go(-1)
    },
    handleClick (type, item, group, index) {
      this.seleValue = item.select
      this.nowSelectGroup = group
      this.nowSelectItemIndex = index
      this.checkType = type
      if (this.checkType === 'erro') {
        this.dialogVisible = true
        this.checkedAss = this.form[this.nowSelectGroup][this.nowSelectItemIndex].bodyPart
        this.dialogSelection = this.form[this.nowSelectGroup][this.nowSelectItemIndex].select
        // console.log('===:::', this.dialogSelection)
      } else if (this.checkType === 'sens') {
        this.dialogVisible2 = true
        this.checkedAss = this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedAss2
      }
      this.curProjectName = this.form[this.nowSelectGroup][this.nowSelectItemIndex].title
      // if (item.select === '未选' && this.checkType === 'erro') {
      //   this.dialogVisible = true
      // } else {
      //   this.dialogVisible2 = true
      //   if (this.checkType === 'erro') {
      //     this.checkedAss = this.form[this.nowSelectGroup][this.nowSelectItemIndex].bodyPart
      //   } else if (this.checkType === 'sens') {
      //     this.checkedAss = this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedAss2
      //   }
      // }
    },
    handleTabClick (tab) {
      // console.log('====>>', this.selectedValues[tab.index])
      // if (this.prevTabIndex !== tab.index) {
      //   this.$set(this.tabDataArray, this.prevTabIndex, ...this.form)
      //   // this.tabDataArray.splice(this.prevTabIndex, 0, ...this.form)
      //   this.prevTabIndex = tab.index
      // }
      const currentIndex = parseInt(tab.index)
      this.saveData(1)
      this.form = this.tabDataArray[tab.name]
      this.isDisabled = this.form.is_finish
      this.showReport = this.form.is_finish
      // 切换学生时重设子tab为第一个可见项
      if (this.form.grossMotor && this.form.grossMotor.length > 0) {
        this.activeName1 = '1'
      } else if (this.form.grossMotorDynamic && this.form.grossMotorDynamic.length > 0) {
        this.activeName1 = '2'
      } else if (this.form.fineMotor && this.form.fineMotor.length > 0) {
        this.activeName1 = '3'
      } else if (this.form.fineMotorDynamic && this.form.fineMotorDynamic.length > 0) {
        this.activeName1 = '4'
      } else {
        this.activeName1 = '5'
      }
      this.showReport = this.form.is_finish
      console.log('tabDataArray=tab=chg===', this.tabDataArray)
     /*  this.form.grossMotor = this.tabDataArray[currentIndex].grossMotor
      this.form.grossMotorDynamic = this.tabDataArray[currentIndex].grossMotorDynamic
      this.form.fineMotor = this.tabDataArray[currentIndex].fineMotor
      this.form.fineMotorDynamic = this.tabDataArray[currentIndex].fineMotorDynamic
      this.form.evaluationObservation = this.tabDataArray[currentIndex].evaluationObservation
      this.form.energyState = this.tabDataArray[currentIndex].energyState */
    },
    
    handleRadioChange () {
      this.isDisabled = false
    },
    changeTypeValue (item, index) {
      // console.log(item)
      this.curTypeValue = item.dic_type
      // console.log(this.curTypeValue)
      for (var k in this.dictData) {
        this.dictData[k].class = ''
      }
      this.dictData[index].class = 'is-active'
    },
    confirmSelection () {
      const selectMap = {
        // 'exce': '优秀',
        '优秀': '优秀',
        // 'stand': '标准',
        '标准': '标准',
        // 'error': '错误',
        '错误': '错误',
        // 'cant': '不会'
        '不会': '不会'
      }
      if (selectMap[this.dialogSelection]) {
        this.form[this.nowSelectGroup][this.nowSelectItemIndex].select = selectMap[this.dialogSelection]
      }
      if (this.dialogSelection.length === 0) {
        return
      }
      this.dialogVisible = false
      this.dialogSelection = ''
      if (this.checkType === 'erro') {
        this.form[this.nowSelectGroup][this.nowSelectItemIndex].bodyPart = this.checkedAss
        this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedLength1 = this.checkedAss.length
      }
      // if (this.checkType === 'erro') {
      //   this.form[this.nowSelectGroup][this.nowSelectItemIndex].bodyPart = this.checkedAss
      //   this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedLength1 = this.checkedAss.length
      // } else if (this.checkType === 'sens') {
      //   this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedAss2 = this.checkedAss
      //   this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedLength2 = this.checkedAss.length
      // }
      this.checkedAss = []
      // this.isDisabled = true
    },
    handleDialogClose (done) {
      this.dialogVisible = false
    },
    confirmScoring () {
      this.dialogVisible2 = false
      // if (this.checkType === 'erro') {
      //   this.form[this.nowSelectGroup][this.nowSelectItemIndex].bodyPart = this.checkedAss
      //   this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedLength1 = this.checkedAss.length
      // } else if (this.checkType === 'sens') {
      //   this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedAss2 = this.checkedAss
      //   this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedLength2 = this.checkedAss.length
      // }
      if (this.checkType === 'sens') {
        this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedAss2 = this.checkedAss
        this.form[this.nowSelectGroup][this.nowSelectItemIndex].checkedLength2 = this.checkedAss.length
      }
      this.checkedAss = []
    },
    async saveData (noAlert) {
      // 保存数据的逻辑
      // console.log(this.check)
      // console.log(this.form)
      if(this.form.evaluationObservationChecked.length>15){
        this.$message.error('评价观察最多选择15个！')
        return
      }
      const params = {
        evalua_id: this.form.evalua_id,
        form: JSON.stringify(this.form)
      }
      const fData = await saveEvaluaData(params)
      console.log(fData)
      if (!noAlert) {
        this.showSave = 'open'
        this.showSub = 'close'
        setTimeout(() => {
          this.showSave = 'close'
        }, 3000)
      }
    },
    submitEvaluation () {
      let sname = this.form.student_name
      // console.log('=====form', this.form)
      // 提交测评的逻辑
      this.$confirm('当前学生【' + sname + '】' + '，提交后无法更改测评项，请先仔细检查，确定要提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 用户点击了确认按钮，执行后续操作
        // 显示查看报告按钮
        this.showReport = true
        this.showSave = 'close'
        this.showSub = 'open'
        this.form.is_finish = true
        await saveEvaluaFinish({
          student_id: this.form.student_id,
          evalua_id: this.form.evalua_id,
          form: JSON.stringify(this.form)
        })
        this.showSub = 'close'
        location.reload()
        /* setTimeout(() => {
          this.showSub = 'close'
        }, 3000) */
      }).catch(() => {
        // 用户点击了取消按钮，或者关闭了确认框
        console.log('用户取消了操作')
      })
    },
    async viewReport () {
      this.dialogVisible3 = false
      // 查看报告的逻辑
      const result = await viewReport({
          student_id: this.form.student_id,
          evalua_id: this.form.evalua_id
      })
      // html
      // this.generatePDF(result.html)
      console.log(result)
      // 更新下载链接
      this.downloadUrl = result.url
      // 等待下一个DOM更新周期
      this.$nextTick(() => {
          // 触发虚拟点击
          this.$refs.downloadLink.click()
      })
    },
    async previewReport (event) {
      console.log('预览报告按钮被点击:', event);
      // 显示加载层
      this.loadingInstance = Loading.service({ fullscreen: true })
      //this.loading = true;
      try {
        const result = await viewReport({
            student_id: this.form.student_id,
            evalua_id: this.form.evalua_id,
            preview: true,
        });
        //this.appStore.setItem('PreviewReportHtml',result.html)
        this.appStore.setItem('htmlUrl',result.pdfPath)
        this.loadingInstance && this.loadingInstance.close()
        //console.log('预览报告：', this.appStore.cache.previewReportHtml);
        /* this.$store.commit('setPreviewReport', {
            //html: result.html,
            url: result.url
        });
        console.log('预览报告：', this.$store); */
        //先不编辑
        /* this.$router.push('/previewreport').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
                throw err;
            }
        }); */
        const ageAry = this.form.age.split('岁')
        this.$router.push({ path: '/previewreporthtml', query: { eid: this.form.evalua_id ,sid: this.form.student_id, age: ageAry[0]} }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
                throw err;
            }
        });

      } catch (error) {
        // console.error('Failed to view report:', error);
        // this.$message.error('预览报告失败，请稍后重试');
      } finally {
        // this.loading = false;
      }      
    },
    confirmReport() {
      // 确认报告的逻辑
      this.$confirm('确认报告后不能再调整训练方案和级别等，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户点击了确定按钮，执行API请求
        //this.apiRequest();
        console.log('用户确定操作')
        this.showDrawer = false
        console.log('确认报告：', this.form.evalua_id);
        this.form['status'] = 2
        const params = {
          evalua_id: this.form.evalua_id,
          status: 2,
          form: JSON.stringify(this.form)
        }
        const fData = saveEvaluaData(params)
        fData.then(() => {
            this.$message.success(`确认成功！`)  
            //等下一次再测试时，把这个status设置为9，变成已完成状态，不能再修改了，也就是历史数据了
          }
        ).catch(() => {
            this.$message.error(`确认失败！`)  
          }
        )
      }).catch(() => {
        // 用户点击了取消按钮，不执行任何操作
        console.log('用户取消了操作')
      });
    },
    reEvaluate() {
      // 重新测评的逻辑
      //user status = 5 //等待测评
      const params = {
        id: this.form.student_id,
        status: 5
      }
      const fData = userEditMultiple(params)
      fData.then(() => {
          //this.$message.success(`重新测评成功！`)
          this.$router.push('/table')
        }
      ).catch(() => {
          this.$message.error(`重新测评失败！`)
        }
      )
    },
    handleChange (value) {
      console.log(value)
    },
    /* generatePDF (htmlStr) {
      // const element = this.$refs.pdfContent

      // 设置 pdf 的选项
      const opt = {
        margin: 1,
        filename: 'document.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      }

      // 使用 html2pdf.js 生成 pdf
      html2pdf()
        // .from(element)
        .from(htmlStr)
        .set(opt)
        .save()
    } */
  }
}
</script>
<style>
@import '../css/evalua.css';
</style>



// WEBPACK FOOTER //
// src/views/Evalua.vue